import React from 'react'
import CustomToolTip from '@Components/Tooltips/CustomToolTip'

const ContactAddressTooltip = () => (
    <CustomToolTip
        type="?"
        info={
            'Mailing address information is completely optional. ' +
            'If you would like to include an address, you may use a P.O. Box or care/of address.'
        }
        place="right"
    />
)

export default ContactAddressTooltip
